import * as actionTypes from './actionTypes';
import adminSvc from '../../axios-admsvc';
import adminDisableSvc from '../../axios-admsvc-disable';
import { SESSION, SESSION_UUID, SESSION_USERNAME, SESSION_SUPERUSER, SESSION_USERTYPE, AgentRoles, SESSION_SUPERVISORUSER, SESSION_TIER1USER, SESSION_READONLYUSER, SESSION_BASELINEAGENT } from "../../shared/Constants";
import { isPrivilegedUser } from '../../shared/utility';
import { fetchDisabledPortals } from './addEligibility';

export const checkSuperUserSuccess = (superUserAccess) => {
    // console.log("[checkSuperUserSuccess]", superUserAccess);
    return {
        type: actionTypes.CHECK_SUPER_USER_SUCCESS,
        superUser: superUserAccess
    }
}

export const checkSuperUserFail = (error) => {
    return {
        type: actionTypes.CHECK_SUPER_USER_FAIL,
        error: error
    }
}

export const checkSuperUser = (userLoginId, envName) => {
    // console.log("[checkSuperUser] request ", userLoginId, envName);
    return dispatch => {
        adminSvc.get("/search/checkSuperUser?username="+userLoginId+"&env="+envName)
            .then(response => {
                // console.log("[checkSuperUser] response ", response.data.access);
                let superUserResponse = response.data.access==="true";
                localStorage.setItem(SESSION_SUPERUSER, superUserResponse);
                // for development and testing purpose enabling specific users functionality to swtich between superuser and teir 1 user
                let superUserLocalStorage = isPrivilegedUser(userLoginId, envName) && localStorage.getItem(SESSION_SUPERUSER) ?
                                                localStorage.getItem(SESSION_SUPERUSER)==="true" && superUserResponse : superUserResponse;
                dispatch(checkSuperUserSuccess(superUserLocalStorage));
            })
            .catch(error => {
                dispatch(checkSuperUserFail(error));
            });
    }
}

export const checkAgentAccess = (userLoginId, envName, data) => {
    const superAdminUser = "SuperAdminUser";
    return dispatch => {
            adminSvc.get("/search/checkAgentAccessType/v2?username="+userLoginId+"&env="+envName)
            .then(response => {
                // if(response.data.agentType){
                //     if(response.data.agentType === 'NoAccess'){
                //         window.location = window.location.protocol+"//"+window.location.host+"/error"
                //     }else{
                //         const agentType = response.data.agentType;
                //         const agentEmailId = response.data.agentEmailId;
                //         if(agentType === superAdminUser){
                //             localStorage.setItem(SESSION_USERTYPE, SESSION_SUPERUSER);
                //             dispatch(checkAgentAccessSuccess(SESSION_SUPERUSER, agentEmailId));
                //             dispatch(checkDisableUserSuccess(true));
                //         }else{
                //             localStorage.setItem(SESSION_USERTYPE, agentType);
                //             dispatch(checkAgentAccessSuccess(agentType, agentEmailId));
                //             dispatch(checkDisableUserFail(false));
                //         }
                //         dispatch(fetchDisabledPortals());
                //     }
                // }
                if(response.data.userGroups) {
                    const agentType = getAgentType(response.data.userGroups, envName);
                    const agentEmailId = response.data.agentEmailId;
                    const body = {
                        agentId: userLoginId,
                        email: response.data.agentEmailId,
                        superUser: [superAdminUser, SESSION_SUPERUSER].includes(agentType)
                    }
                    adminSvc.post("/agent/login/info",body, {
                        headers:{
                            SM_USER: data?.profile?.name,
                            firstname: data?.profile?.name,
                        }
                    })
                    .catch((e)=>{
                        // console.log('e')
                    })
                    if (agentType === "NoAccess") {
                    window.location =
                        window.location.protocol +
                        "//" +
                        window.location.host +
                        "/error";
                    } else {
                        if (agentType === superAdminUser) {
                            localStorage.setItem(SESSION_USERTYPE, SESSION_SUPERUSER);
                            dispatch(
                            checkAgentAccessSuccess(SESSION_SUPERUSER, agentEmailId, response.data?.featureTestRole, response.data?.features)
                            );
                            dispatch(checkDisableUserSuccess(true));
                        } else {
                            localStorage.setItem(SESSION_USERTYPE, agentType);
                            dispatch(checkAgentAccessSuccess(agentType, agentEmailId, response.data?.featureTestRole, response.data?.features));
                            dispatch(checkDisableUserFail(false));
                        }
                        dispatch(fetchDisabledPortals());
                    }
                }
            })
            .catch(error => {
                dispatch(checkAgentAccessFail(error));
            });
        
    }
}

const getAgentType=( userGroups, envName) =>{
    let agentType = AgentRoles.NOACCESS;
    const env = ["production", "productionoso"].includes(envName) ? "Prod" : "Non_Prod";
    if (userGroups.indexOf(`HealthSafe_Admin_${AgentRoles.SUPER_ADMIN_USER}_${env}`) >-1) {
        agentType = AgentRoles.SUPER_ADMIN_USER;
    } else if (userGroups.indexOf(`HealthSafe_Admin_${AgentRoles.SUPER_USER}_${env}`)>-1) {
        agentType = SESSION_SUPERUSER;
    } else if (userGroups.indexOf(`HealthSafe_Admin_${AgentRoles.SUPERVISOR}_${env}`)>-1) {
        agentType = SESSION_SUPERVISORUSER;
    } else if (userGroups.indexOf(`HealthSafe_Admin_${AgentRoles.TIER1}_${env}`)>-1) {
        agentType = SESSION_TIER1USER;
    } else if (userGroups.indexOf(`HealthSafe_Admin_${AgentRoles.READONLY}_${env}`)>-1) {
        agentType = SESSION_READONLYUSER;
    } else if( userGroups.indexOf(`HealthSafe_Admin_${AgentRoles.BASELINE}_${env}`)>-1){
        agentType = SESSION_BASELINEAGENT;
    }
    return agentType;
}

export const checkAgentAccessSuccess = (userType, agentEmailId, featureRole, features) => {
    return {
        type: actionTypes.CHECK_AGENT_ACCESS_SUCCESS,
        userType: userType,
        agentEmailId: agentEmailId,
        featureTestRole: featureRole,
        features,
    }
}

export const checkAgentAccessFail = (error) => {
    return {
        type: actionTypes.CHECK_AGENT_ACCESS_FAIL,
        error: error
    }
}

export const checkDisableUserSuccess = (bulkDisableUser) => {
    // console.log("[checkSuperUserSuccess]", superUserAccess);
    return {
        type: actionTypes.CHECK_DISABLE_USER_SUCCESS,
        disableUser: bulkDisableUser
    }
}

export const checkDisableUserFail = (bulkDisableUser) => {
    return {
        type: actionTypes.CHECK_DISABLE_USER_FAIL,
        disableUser: bulkDisableUser
    }
}

export const setUserSession = (username) => {
    return {
        type: actionTypes.SET_USER_SESSION,
        username: username
    }
}

export const logoutUser = (fn) => {
    return dispatch => {
        
        // if(process.env.REACT_APP_ADMIN_LOGOUT) {
        //     window.location=process.env.REACT_APP_ADMIN_LOGOUT;
        // }
        // if(fn) {
        //     fn()
        // } else if(process.env.REACT_APP_COGNITO_CLIENTID && process.env.REACT_APP_ADMIN_SERVICE_HOST &&
        //     process.env.REACT_APP_COGNITO_DOMAIN
        // ) {
        //     const clientId = process.env.REACT_APP_COGNITO_CLIENTID;
        //     const logoutUri = `${process.env.REACT_APP_ADMIN_SERVICE_HOST}/logout`;
        //     const cognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN;
        //     window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(
        //     logoutUri
        //     )}`;
        // } else {
        //     window.location=window.location.protocol+"//"+window.location.host+"/logout";
        // }
        adminSvc.get("/logout")
            .then((res)=>{
                console.log('logout url', res.data)
                const url = res.data?.logoutUrl
                localStorage.clear();
                window.location.href = url;
                // window.location=window.location.protocol+"//"+window.location.host+"/logout";
            })
            .catch((e)=>{
                console.log('logout error', JSON.stringify(e), e.response)
                localStorage.clear();
                window.location=window.location.protocol+"//"+window.location.host+"/logout";
            })
        dispatch(logout());
    }
}

export const logout = () => {
    return {
        type: actionTypes.LOGOUT_USER
    }
}

export const fetchUser = (data) => {
    return dispatch => {
        // if(!data) {
            dispatch(fetchUserStart());
            adminSvc.get("/user", {
                headers:{
                    SM_USER: data?.profile?.name,
                    firstname: data?.profile?.name,
                }
            })
                .then(response => {
                    localStorage.removeItem(SESSION);
                    localStorage.removeItem(SESSION_UUID);
                    localStorage.removeItem(SESSION_USERNAME);
                    dispatch(fetchUserSuccess(response.data));
                    dispatch(setUserSession(response.data.username));
                    dispatch(checkAgentAccess(response.data.username, process.env.NODE_ENV));
                    dispatch(fetchAccessTokenSuccess(response.data.token));
                    if(process.env.NODE_ENV === "test" || process.env.NODE_ENV === "testoso"){
                        dispatch(checkDisableUserFail(false));
                    }
                })
                .catch(error => {
                    console.log('error in fetch user', JSON.stringify(error))
                    if(error.response?.data?.authUrl) {
                        // window.location.href = error.response.data.authUrl
                        window.location.replace(error.response.data.authUrl)
                    }
                    if(!(error?.response?.status === 401)) {
                        console.log('entered in 401', error.status)
                        dispatch(fetchUserFailure(error));
                    }
                    // dispatch(fetchUserFailure(error));
                //TODO:Start: only for local, when proxy is not being used
                //TODO:End: only for local
            });
        // } else {
        //     const val = {
        //         username: data.profile.name,
        //         name: data.profile.name,
        //         token: `Basic YWRtU3ZjVXNlcjpObWRAQ3ZzMjAxNw==`
        //     }
        //     localStorage.removeItem(SESSION);
        //     localStorage.removeItem(SESSION_UUID);
        //     localStorage.removeItem(SESSION_USERNAME);
        //     dispatch(fetchUserSuccess(val));
        //     dispatch(setUserSession(val.username));
        //     dispatch(checkAgentAccess(val.username, process.env.NODE_ENV, {
        //         agentEmailId: data.profile.email,
        //         userGroups: data.profile["custom:roles_engg"]
        //     }));
        //     dispatch(fetchAccessTokenSuccess(val.token));
        //     if(process.env.NODE_ENV === "test" || process.env.NODE_ENV === "testoso"){
        //         dispatch(checkDisableUserFail(false));
        //     }
        // }
            
    }
}

export const fetchUserStart = () => {
    return {
        type: actionTypes.FETCH_USER_START
    }
}

export const fetchUserSuccess = (user) => {
    return {
        type: actionTypes.FETCH_USER_SUCCESS,
        user: user
    }
}

export const fetchUserFailure = (error) => {
    return {
        type: actionTypes.FETCH_USER_FAILED,
        error: error
    }
}

export const fetchAccessTokenSuccess = (token) => {
    return {
        type: actionTypes.FETCH_ACCESS_TOKEN,
        token: token
    }
}
